import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addTagsToCustomerErrorTitle: {
    description: 'customers.addTagsToCustomerErrorTitle',
    defaultMessage: 'Tag Error',
    id: 'aGW263',
  },
  addTagsToCustomerErrorMessage: {
    description: 'customers.addTagsToCustomerErrorMessage',
    defaultMessage: 'Tags could not be changed at this time. Please try again.',
    id: 'Yh3PXZ',
  },
  createCustomerErrorTitle: {
    description: 'Title for create customer error modal',
    defaultMessage: 'Create Customer Error',
    id: '+3cu39',
  },
  createCustomerErrorMessage: {
    description: 'Message for create customer error modal',
    defaultMessage: 'The customer could not be created at this time. Please try again.',
    id: 'ewPvci',
  },
  deleteCustomerErrorTitle: {
    description: 'Title for delete customer error modal',
    defaultMessage: 'Delete Customer Error',
    id: 'YxzdXj',
  },
  deleteCustomerErrorMessage: {
    description: 'Message for delete customer error modal',
    defaultMessage: 'The customer could not be deleted at this time. Please try again.',
    id: '47p94R',
  },
  updateCustomerErrorTitle: {
    description: 'Error title for update customer failure',
    defaultMessage: 'Update Customer Failed',
    id: 'ndbVYq',
  },
  updateCustomerErrorMessage: {
    description: 'Error message for update customer failure',
    defaultMessage: 'Failed to update customer. Please try again.',
    id: '2l3nX+',
  },
});
